import styled from 'styled-components'

export const Container = styled.div`
    float: left;
    width: 100%;
    background: #1a2634;
    padding: 0 60px;
    position: relative;
    display: flex;
    align-items: center;

    @media (max-width: 1500px) {
        flex-direction: column-reverse;
        padding: 40px;
    }

    @media (max-width: 768px) {
        padding: 30px 20px;
    }
`

export const BoxTextos = styled.div`
    float: left;
    width: 40%;

    @media (max-width: 1500px) {
        width: 100%;
        margin-top: 40px;
    }
`

export const Titulo = styled.span`
    float: left;
    width: 100%;
    color: #E4B55C;
    font-size: 30px;
    font-weight: 700;
    line-height: 40px;
    margin: 0 0 30px 0;

    @media (max-width: 1700px) {
        br {
            display: none;
        }
    }

    @media (max-width: 768px) {
        font-size: 20px;
        line-height: 30px;
        margin: 0 0 20px 0;
    }

`

export const Texto = styled.span`
    float: left;
    width: 100%;
    color: #fff;
    font-size: 15px;
    line-height: 24px;

    + span {
        margin-top: 20px;
    }
`

export const BoxImagem = styled.figure`
    float: right;
    width: 60%;
    text-align: center;

    @media (max-width: 1500px) {
        width: 100%;
    }
`

export const Imagem = styled.img`
    display: inline-block;
    max-width: 100%;
`